<main class="autonome-main">
  <div class="autonome-left-padding"></div>
  <div class="autonome-middle-container">
    <app-autonome class="app-autonome"></app-autonome>
    <router-outlet class="app-router-outlet"></router-outlet>
    <div class="autonome-bottom-padding"></div>
  </div>
  <div class="autonome-right-padding"></div>
</main>